<template>
  <div class="comment">
    <div class="comment-box">
      <div class="comment-box-header">
        <div class="header-left">
          <div class="header-left-text">Hi,&nbsp;{{ userName }}</div>
          <div class="header-left-button" v-permission="'order:add'">
            <el-button type="primary" @click="handleAddProjectOrder">
              <i class="el-icon-plus"></i>新建订单
            </el-button>
          </div>
          <div class="header-left-mon" v-permission="'balance'">
            <div>
              <p class="left-mon-text">账户余额(元)</p>
              <p>
                <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
              </p>
            </div>
            <p class="left-mon-num" @click="handleToFinancial">{{ toLocaleString(balance) }}</p>
          </div>
          <div class="header-left-mon" v-permission="'freeze'">
            <div>
              <p class="left-mon-text">冻结金额(元)</p>
              <p>
                <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
              </p>
            </div>
            <p class="left-mon-num" @click="handleToFinancial">{{ toLocaleString(freezeBalance) }}</p>
          </div>
        </div>
        <div class="header-right">
          <ContentBox style="height: 395px; width: 100%">
            <div slot="title" class="box-title">
              <p>投放数据</p>
              <p>
                <span></span>
                <!-- <i class="el-icon-arrow-right"></i> -->
              </p>
            </div>
            <div v-permission="'putAmount:list'">
              <VeLine
                :extend="advertiseChart.extend"
                :loading="loading.line"
                :data="advertiseChart.data"
                :settings="advertiseChart.settings"
                :series="advertiseChart.series"
                height="310px"
              ></VeLine>
            </div>
          </ContentBox>
        </div>
      </div>
      <div class="comment-box-center">
        <div class="center-card" v-for="(item, index) in scheduleList" :key="index" @click="handleFilterSchedule(index)">
          <div>
            <p class="center-card-text">{{ item.label }}</p>
            <p class="center-card-num">{{ item.value }}</p>
          </div>
          <div>
            <img :src="item.img" />
          </div>
        </div>
      </div>
      <div class="comment-box-bottom">
        <div class="bottom-left">
          <ContentBox>
            <div slot="title" class="box-title">
              <p>
                地域分布
                <i class="el-icon-cc-info-circle" style="font-size: 14px; color: rgba(0, 0, 0, 0.45)"></i>
              </p>
              <p @click="handleToAreaDataReport" v-permission="'regionData:more'">
                <span>更多</span>
                <i class="el-icon-arrow-right"></i>
              </p>
            </div>
            <div v-if="regionOption.series[0].data.length" style="height: 400px">
              <Echarts elId="ChinaMap" :option="regionOption" height="400px" width="440px"></Echarts>
            </div>
            <div v-else class="no-message">
              <ChartDataEmpty />
            </div>
          </ContentBox>
        </div>
        <div class="bottom-right">
          <ContentBox>
            <div slot="title" class="box-title">
              <p>
                订单完成进度
                <i class="el-icon-cc-info-circle" style="font-size: 14px; color: rgba(0, 0, 0, 0.45)"></i>
              </p>
              <p>
                <span></span>
              </p>
            </div>
            <Table
              :data="table.data"
              :header="table.header"
              :props="table.props"
              :select-on-row-click="true"
              @row-click="handleRowClick"
              style="margin-top: 16px"
              v-permission="'progress:list'"
              v-loading="loading.table"
            />
          </ContentBox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VeLine from 'v-charts/lib/line.common'
// import VePie from 'v-charts/lib/pie.common'
import 'v-charts/lib/style.css'
// import echarts from 'echarts'
// import VeMap from 'v-charts/lib/map.common'
import Echarts from '@/components/charts/Echarts.vue'
import ChartDataEmpty from '@/components/ChartDataEmpty'
export default {
  components: {
    VeLine,
    Echarts,
    ChartDataEmpty
    // VeMap
  },
  data() {
    return {
      freezeBalance: 0, // 冻结金额
      balance: 0, // 账户余额

      // 投放数据
      advertiseChart: {
        data: {
          columns: ['date', 'traffic', 'sendAmount'],
          rows: []
        },
        settings: {
          labelMap: {
            traffic: '计划量',
            sendAmount: '曝光量'
          }
        },
        series: [
          {
            name: '计划量',
            type: 'line',
            symbol: 'circle',
            showSymbol: false,
            symbolSize: 2,
            smooth: true,
            lineStyle: {
              normal: {
                color: '#CDDDFD' // 线条颜色
              }
            },
            itemStyle: {
              color: '#CDDDFD'
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#CDDDFD' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#fff' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            },
            data: []
          },
          {
            name: '曝光量',
            type: 'line',
            symbol: 'circle',
            showSymbol: true,
            symbolSize: 2,
            smooth: true,
            lineStyle: {
              normal: {
                color: '#F6BD16' // 线条颜色
              }
            },
            itemStyle: {
              color: '#F6BD16'
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#F6BD16' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#fff' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            },
            data: []
          }
        ],
        extend: {
          tooltip: {
            confine: true
          },
          legend: {
            data: ['计划量', '曝光量'],
            right: 0,
            top: 5,
            icon: 'rect',
            itemWidth: 10,
            itemHeight: 2,
            itemGap: 25
          },
          grid: {
            left: 16,
            right: 16,
            top: 35,
            bottom: '0'
          },
          xAxis: {
            axisLine: {
              show: true,
              lineStyle: {
                color: '#999999',
                type: 'solid'
              }
            },
            axisTick: {
              show: true
            }
          },
          yAxis: {
            splitLine: {
              lineStyle: { type: 'dashed' }
            }
          }
        }
      },
      regionOption: {
        tooltip: {
          triggerOn: 'mousemove',
          formatter: function (e, t, n) {
            return e.seriesName + '<br />' + e.name + ':' + e.value
          }
        },
        visualMap: {
          min: 0,
          max: 100,
          show: false
        },
        geo: {
          map: 'china',
          center: [108, 35],
          roam: !1,
          scaleLimit: {
            min: 1,
            max: 2
          },
          zoom: 1.1,
          label: {
            normal: {
              show: !0,
              fontSize: '12',
              color: 'rgba(0,0,0,0.7)'
            }
          },
          itemStyle: {
            normal: {
              borderColor: 'rgba(0, 0, 0, 0.5)'
            },
            emphasis: {
              areaColor: '#f2d5ad',
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              borderWidth: 0
            }
          }
        },
        series: [{
          name: '曝光量',
          type: 'map',
          geoIndex: 0,
          data: []
        }]
      },
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '订单名称',
            prop: 'orderName',
            center: 'left',
            'show-overflow-tooltip': true,
            'min-width': 260,
            // width: 266,
            formatter: (params) => {
              if (params.orderName === '') {
                return '--'
              } else {
                return params.orderName
              }
            }
          },
          {
            label: '合约时间',
            prop: 'orderTime',
            center: 'left',
            'show-overflow-tooltip': true,
            'min-width': 210,
            formatter: (params) => {
              if (params.orderTime === '') {
                return '--'
              } else {
                return params.orderTime
              }
            }
          },
          {
            label: '总计划量(PV)',
            prop: 'totalTraffic',
            align: 'right',
            'show-overflow-tooltip': true,
            'min-width': 120,
            // 'min-width': 90,
            formatter: (params) => {
              if (params.totalTraffic === '') {
                return '--'
              } else {
                return (params.totalTraffic || 0).toLocaleString()
              }
            }
          },
          {
            label: '总曝光量(PV)',
            prop: 'totalSendAmount',
            align: 'right',
            'show-overflow-tooltip': true,
            'min-width': 120,
            formatter: (params) => {
              if (params.totalSendAmount === '') {
                return '--'
              } else {
                return (params.totalSendAmount || 0).toLocaleString()
              }
            }
          },
          {
            label: '完成进度',
            prop: 'rate',
            align: 'right',
            'show-overflow-tooltip': true,
            'min-width': 120,
            formatter: (params) => {
              if (params.rate === '') {
                return '--'
              } else {
                return params.rate
              }
            }
          }
        ],
        data: []
      },
      loading: {
        line: false,
        map: false,
        tabel: false
      },
      scheduleList: [
        {
          label: '投放中计划',
          value: '',
          img: require('../../assets/login-icon-analyse.png')
        },
        {
          label: '待投放计划',
          value: '',
          img: require('../../assets/login-icon-monitor.png')
        },
        {
          label: '暂停计划',
          value: '',
          img: require('../../assets/login-icon-scene.png')
        },
        {
          label: '今日新增计划',
          value: '',
          img: require('../../assets/login-icon-advertise.png')
        }
      ]
    }
  },
  computed: {
    userName() {
      const user = this.$service.state.user || {}
      return user.userName
    }
  },
  methods: {
    handleAddProjectOrder() {
      this.$router.push({ name: 'projectOrder', params: { add: true } })
    },
    handleFilterSchedule(index) {
      if (index === 0) {
        this.$router.push({
          name: 'adServingManage',
          params: {
            scheduleStatus: 4
          }
        })
      } else if (index === 1) {
        this.$router.push({
          name: 'adServingManage',
          params: {
            scheduleStatus: 3
          }
        })
      } else if (index === 2) {
        this.$router.push({
          name: 'adServingManage',
          params: {
            scheduleStatus: 9
          }
        })
      } else {
        // 今日新增，无筛选条件
        this.$router.push({
          name: 'adServingManage'
        })
      }
    },
    handleToAreaDataReport() {
      this.$router.push({
        name: 'areaData',
        params: {
          order: {}
        }
      })
    },
    handleToFinancial() {
      this.$router.push({
        name: 'financialIndex'
      })
    },
    toLocaleString(number) {
      return number.toLocaleString('en-IN', { minimumFractionDigits: 2 })
    },
    refrashData() {
      this.getHomeData()
      this.getHomeLine()
      this.getHomeMap()
      this.getHomeOrder()
    },
    getHomeData() {
      this.$service
        .getHomeData()
        .then((data) => {
          this.balance = data.balance || 0
          this.freezeBalance = data.freezeBalance || 0
          // 各种投放数据
          this.scheduleList.forEach((item, index) => {
            if (index === 0) {
              item.value = data.scheduleStatus_4 || 0
            } else if (index === 1) {
              item.value = data.scheduleStatus_3 || 0
            } else if (index === 2) {
              item.value = data.scheduleStatus_9 || 0
            } else {
              item.value = data.dailyCount || 0
            }
          })
        })
        .catch(() => {})
    },
    getHomeLine() {
      this.loading.line = true
      this.$service
        .getHomeLine()
        .then((data) => {
          // 曝光
          this.advertiseChart.series[1].data = data.line.sendAmount.data.map((item) => {
            return item.yData
          })
          // 计划
          this.advertiseChart.series[0].data = data.line.traffic.data.map((item) => {
            return item.yData
          })
          // 投放数据
          let lineRow = data.line.sendAmount.data.map((item) => {
            return {
              date: item.xData,
              sendAmount: item.yData,
              traffic: 0
            }
          })
          data.line.traffic.data.forEach((item, index) => {
            lineRow[index].traffic = item.yData
          })
          this.advertiseChart.data.rows = lineRow
          this.loading.line = false
        })
        .catch(() => {
          this.loading.line = false
        })
    },
    getHomeMap() {
      this.$service
        .getHomeMap()
        .then((data) => {
          if (data.map.data) {
            this.regionOption.series[0].data = data.map.data.map((item) => {
              return {
                name: item.xData.indexOf('自治区') === -1 ? item.xData.replace('省', '').replace('市', '') : this.getSpecialProName(item.xData),
                value: item.yData
              }
            })
          }
        })
    },
    getSpecialProName(name) {
      if (name.indexOf('内蒙古') !== -1) {
        return name.substring(0, 3)
      } else {
        return name.substring(0, 2)
      }
    },
    getHomeOrder() {
      this.loading.table = true
      this.$service
        .getHomeOrder()
        .then((data) => {
          // 订单完成进度数据
          let tableData = data.orderList || []
          if (tableData.length < 5) {
            for (var i = tableData.length; i < 5; i++) {
              tableData.push({
                orderId: '',
                orderName: '',
                orderTime: '',
                rate: '',
                totalSendAmount: '',
                totalTraffic: ''
              })
            }
          }
          this.table.data = tableData
          this.loading.table = false
        })
        .catch(() => {
          this.loading.table = false
        })
    },
    handleRowClick(row, index) {
      const contractTime = row.orderTime
        ? row.orderTime.split('~')
        : [new Date(), new Date()]
      const order = {
        orderId: row.orderId,
        orderName: row.orderName,
        contractBeginDate: contractTime[0],
        contractEndDate: contractTime[1]
      }
      this.$router.push({
        name: 'orderBasicData',
        params: {
          order: order
        }
      })
    }
  },
  created() {
    this.refrashData()
  }
}
</script>

 <style lang="stylus" scoped>
 .comment-box-header
   display flex
   flex-direction row
   margin 16px 16px 16px 16px
   height 395px
 .header-left
   display flex
   flex-direction column
   background-color #fff
   margin-right 16px
   width 268px
 .header-right
   width calc(100% - 284px)
 .header-left>div
   margin-left 38px
 .header-left-text
   width 197px
   height 28px
   font-size 18px
   font-weight 500
   color rgba(0, 0, 0, 0.85)
   line-height 28px
   padding 21px 0 32px 0
   overflow hidden
   white-space nowrap
   text-overflow ellipsis
 .header-left-button
   width 182px
   height 36px
   padding-bottom 32px
 .header-left-button button
   width inherit
 .header-left-mon
   padding-bottom 32px
 .header-left-mon div
   display flex
   flex-direction row
   color rgba(0, 0, 0, 0.45)
 .header-left-mon i
   font-size 14px
 .left-mon-text
   width 90px
   height 22px
   font-size 14px
   font-weight 400
   // color:rgba(0,0,0,0.45);
   line-height 22px
   padding-bottom 5px
 .left-mon-num
   width inherit
   height 38px
   font-size 30px
   font-family HelveticaNeue
   color rgba(0, 0, 0, 0.85)
   line-height 38px
   overflow hidden
   text-overflow ellipsis
   white-space nowrap
   cursor pointer
 .box-title
   display flex
   justify-content space-between
   align-items center
   height 24px
   line-height 24px
   padding 16px 0 15px 23px
   width 100%
 .box-title>p
   cursor pointer
 .box-title p:last-child
   font-size 14px
   width 110px
   height 22px
   font-size 14px
   font-weight 400
   color rgba(0, 0, 0, 0.45)
   line-height 22px
   padding-right 23px
   text-align end
 .content-box
   margin-bottom 0
   height 100%
 >>>.content-box__main
   margin 0 24px
 .comment-box-center
   display flex
   margin-left 16px
   margin-bottom 16px
 .comment-box-center.center-card:last-child
   margin-right 0
 .center-card
   width 25%
   height 104px
   background rgba(255, 255, 255, 1)
   border-radius 2px
   margin-right 16px
   display flex
   flex-direction row
   justify-content space-between
   align-items center
   cursor pointer
 .center-card:hover
   box-shadow 0 2px 12px 0 rgba(0, 0, 0, 0.5)
 .comment-box-center .center-card:nth-child(1)
   border-bottom 5px solid #ff8b00
 .comment-box-center .center-card:nth-child(2)
   border-bottom 5px solid rgba(255, 139, 0, 0.5)
 .comment-box-center .center-card:nth-child(3)
   border-bottom 5px solid rgba(255, 139, 0, 0.75)
 .comment-box-center .center-card:nth-child(4)
   border-bottom 5px solid rgba(255, 139, 0, 0.25)
 .center-card div
   display flex
   flex-direction column
   padding-left 41px
 .center-card-text
   width 92px
   height 22px
   font-size 14px
   font-family PingFangSC-Regular, PingFang SC
   font-weight 400
   color rgba(0, 0, 0, 0.45)
   line-height 22px
 .center-card-num
   overflow hidden
   text-overflow ellipsis
   white-space nowrap
   height 38px
   max-width 170px
   font-size 30px
   font-family HelveticaNeue
   color rgba(0, 0, 0, 0.85)
   line-height 38px
   cursor pointer
 .center-card img
   width 34px
   height 34px
   margin-right 53px
 p
   margin 0
 .comment-box-bottom
   display flex
   flex-direction row
   margin-left 16px
   margin-bottom 16px
 .bottom-left, .bottom-right
   margin-right 16px
 .bottom-left
   width 472px
 .bottom-right
   width calc(100% - 495px)
 >>>.el-table__body tr
   cursor pointer
.no-message
  text-align center
  height 400px
</style>
